/// <reference path="Main.js" />
/// <reference path="Enumeration-vsdoc.js" />
/// <reference path="Strings-vsdoc.js" />
/// <reference path="fetcher.js"/>

/* global fetcher */

window.JJK = window.JJK || {};

// Begin JJK.AboAuftrag *************************************************************************************************
JJK.AboAuftrag = function (options) {
	$.extend(this, options);
	const self = this;
	$(() => {
		self.Init();
	});
};

JJK.AboAuftrag.prototype = {
	AboTemplateId: null,
	SonderpostenArtikelId: null,
	VonId: null,
	VonFormatiertId: null,
	BisFormatiertId: null,
	FormId: null,
	SonderpostenArtikel: null,
	SonderpostenArtikelJson: null,
	ZuzahlungId: null,
	WertAboTemplate: '',
	WertSonderpostenArtikel: '',
	TemplateGewaehltAjaxUrl: null,
	StartdatumGeaendertAjaxUrl: null,
	AboAuftragId: null,
	AboAusgabeId: null,
	RefreshId: null,
	KeineZuzahlung: null,
	ChildAboGewaehltAjaxUrl: null,
	Init: function () {
		this.WertAboTemplate = $(`#${this.AboTemplateId}`).val();
		this.WertSonderpostenArtikel = $(`#${this.SonderpostenArtikelId}`).val();
		this.ErzeugeEvents();
		this.SonderpostenArtikelJson = JSON.parse(this.SonderpostenArtikel);
		this.initLandingpage();
	},
	ErzeugeEvents: function () {
		const self = this;
		$(`#${this.AboTemplateId}`).on('change', function () {
			const wert = $(this).val();
			if (wert !== self.WertAboTemplate) {
				self.WertAboTemplate = wert;
				$(`#${self.RefreshId}`).val(true);
				const send = $(`#${self.FormId}`).serialize();
				$.post(self.TemplateGewaehltAjaxUrl, send, function (received) {
					$(`#${self.AboAuftragId}`).html(received);
					window.setTimeout(() => {
						jjk.initSelect2($('select:not([multiple])', `#${self.AboAuftragId}`));
						window.setTimeout(() => {
							$(`#${self.AboTemplateId}`).trigger('focus');
						}, 0);
					}, 0);
					if (window.AboErmittleDatum) {
						window.AboErmittleDatum.ermittleStartundLetztesVersandDatum();
					}
				});
			}
		});
		if (this.SonderpostenArtikelId) {
			$(`#${this.SonderpostenArtikelId}`).on('change', function () {
				const wert = $(this).val();
				const templateId = $('#GewaehltesAboTemplateId').val();
				if (wert !== self.WertSonderpostenArtikel) {
					self.WertSonderpostenArtikel = wert;
					for (let i = 0; i < self.SonderpostenArtikelJson.length; i++) {
						// ReSharper disable once CoercedEqualsUsing
						// eslint-disable-next-line eqeqeq
						if (self.SonderpostenArtikelJson[i].Id == wert) {
							if (self.SonderpostenArtikelJson[i].ZuzahlungText != null && self.SonderpostenArtikelJson[i].ZuzahlungText !== self.KeineZuzahlung) {
								$(`#${self.ZuzahlungId}`).html(self.SonderpostenArtikelJson[i].ZuzahlungText);
								$(`#zuzahlungsText${templateId}`).show();
							} else {
								$(`#zuzahlungsText${templateId}`).hide();
							}
							break;
						}
					}
				}
			});
		}
		if (this.VonId) {
			$(`#${self.VonId}`).on('change', function () {
				$.post(self.StartdatumGeaendertAjaxUrl, { startDatum: $(this).val() }, function (data) {
					$(`#${self.VonFormatiertId}`).html(data.ErsterLieferterminMitText);
					$(`#${self.BisFormatiertId}`).html(data.LetzterLieferterminMitText);
				});
			});
		}
		$('.sp-artikel-card').on('click', function () {
			const id = $(this).attr('id');
			const sonderpostenId = $(this).data('sonderposten-id');
			$('.sp-artikel-card').removeClass('selected');
			$(`#${id}`).addClass('selected');
			$('#GewaehltePraemie').val(sonderpostenId);
		});

		$('[name^="GewaehlteAbos"]').on('change', async function () {
			const $select = $(this);
			const childAboTemplateId = parseInt($select.val(), 10);
			const text = await fetcher.postJson(self.ChildAboGewaehltAjaxUrl, { childAboTemplateId });
			$select.closest('div').next('.abo-detail-Liefertage').text(text);
		});
	},

	GetGewaehlePraemie: function (gewaehlepraemie) {
		this.WertSonderpostenArtikel = gewaehlepraemie;
		$(`#${this.SonderpostenArtikelId}`).val(gewaehlepraemie);
	},

	resetHeight() {
		$('#floatWorkarround').remove();
		let counter = 0;
		let newHeight = 0;

		const text = document.getElementById('LandingpageText');
		const form = document.getElementById('LandingpageForm');
		const container = text.parentElement;
		const textStyles = window.getComputedStyle(text);
		const formHeight = Math.ceil(form.offsetHeight);

		while (newHeight + formHeight < text.offsetHeight - textStyles.paddingTop.slice(0, -2) - textStyles.paddingBottom.slice(0, -2) && counter < 20) {
			newHeight = Math.round(text.clientHeight - formHeight) - Math.round((container.offsetHeight - text.offsetHeight) / 2);
			$('#floatWorkarround').remove();
			$('head').append(`<style id="floatWorkarround">.aboauftrag_content::before{ height: ${newHeight}px; }</style>`);
			counter += 1;
		}
	},
	initLandingpage() {
		const container = document.querySelector('.aboauftrag_content');
		if (container) {
			this.prevWindowWidth = -1;
			if (container.classList.contains('layout-3') || container.classList.contains('layout-4')) {
				this.resetHeight();
			}
			if (container.classList.contains('layout-1') || container.classList.contains('layout-2') || container.classList.contains('layout-3') || container.classList.contains('layout-4')) {
				const maxWidth = container.classList.contains('layout-1') || container.classList.contains('layout-2') ? 575 : 799;
				const changeTextFirst = (force = false) => {
					if (window.innerWidth > maxWidth && (this.prevWindowWidth <= maxWidth || force)) {
						this.setTextFirst(false);
					} else if (window.innerWidth <= maxWidth && (this.prevWindowWidth > maxWidth || force)) {
						this.setTextFirst();
					}
					this.prevWindowWidth = window.innerWidth;
				};
				changeTextFirst(true);
				window.addEventListener('resize', changeTextFirst.bind(this));
			}
			if (container.classList.contains('layout-7')) {
				this.setTextFirst();
			}
		}
	},
	setTextFirst(firstOrLast = true) {
		const form = document.getElementById('LandingpageForm');
		const text = document.getElementById('LandingpageText');
		if (form) {
			const parent = form.parentElement;
			if (text && 'moveBefore' in document && typeof document.moveBefore == 'function') {
				if (firstOrLast === true) {
					parent.moveBefore(text, form);
				} else {
					parent.moveBefore(form, text);
				}
			} else {
				if (firstOrLast === true) {
					parent.append(form);
				} else {
					parent.prepend(form);
				}
			}
		} else {
			// eslint-disable-next-line no-console
			console.error('setTextFirst', 'form not found');
		}
	},
};

// End JJK.AboAuftrag ***************************************************************************************************
